import React, { useMemo } from 'react'
import { SelectFilter } from 'components/filters'
import {
	REPORT_CALENDAR_FILTER_ALL,
	REPORT_CALENDAR_INITIAL_FILTER_VALUES,
} from '../../reportCalendarMappers'
import '../../styles/report-calendar-filters.sass'

const ALL_OPTION = { value: REPORT_CALENDAR_FILTER_ALL, label: 'All' }

const FILTER_FIELDS = [
	{
		id: 'report-calendar-business-filter',
		key: 'business',
		optionsKey: 'businesses',
		labelPrefix: 'Business:',
	},
	{
		id: 'report-calendar-jurisdiction-filter',
		key: 'jurisdiction',
		optionsKey: 'jurisdictions',
		labelPrefix: 'Jurisdiction:',
	},
	{
		id: 'report-calendar-report-type-filter',
		key: 'reportType',
		optionsKey: 'reportTypes',
		labelPrefix: 'Report type:',
	},
	{
		id: 'report-calendar-status-filter',
		key: 'status',
		optionsKey: 'statuses',
		labelPrefix: 'Status:',
	},
]

const ReportCalendarFilters = ({
	values = REPORT_CALENDAR_INITIAL_FILTER_VALUES,
	options = {
		businesses: [],
		jurisdictions: [],
		reportTypes: [],
		statuses: [],
	},
	onChange,
}) => {
	const fields = useMemo(() => (
		FILTER_FIELDS.map((field) => ({
			...field,
			options: [ALL_OPTION, ...(options[field.optionsKey] ?? [])],
		}))
	), [options])

	const handleFilterChange = (key) => (event) => {
		onChange?.(key, event?.target?.value ?? REPORT_CALENDAR_FILTER_ALL)
	}

	return (
		<div className='reporting-calendar-filters reporting-calendar-filters--toolbar'>
			<span className='reporting-calendar-filters__label'>Filters</span>
			<div className='reporting-calendar-filters__list'>
				{fields.map((field) => (
					<div
						key={field.key}
						className='reporting-calendar-filters__controlSlot'
					>
						<SelectFilter
							id={field.id}
							variant='labeled'
							labelPrefix={field.labelPrefix}
							placeholder='All'
							options={field.options}
							value={values[field.key]}
							onChange={handleFilterChange(field.key)}
							height={36}
							width='fit-content'
							fitWidth
							allowClear
							clearValue={REPORT_CALENDAR_FILTER_ALL}
							className='reporting-calendar-filters__select'
							ariaLabel={`${field.labelPrefix} All`}
						/>
					</div>
				))}
			</div>
		</div>
	)
}

export default ReportCalendarFilters
